<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 15:15:35
 * @LastEditTime: 2025-12-04 10:55:53
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-suggest_question">
    <img src="@/assets/ai_robot.svg" alt="" />
    <div class="c-suggest_question__content">
      <div class="title label">你可能想问</div>
      <el-scrollbar class="c-scrollbar" v-if="suggestQuestionListProp.length">
        <div class="list_wrap">
          <div
            v-for="(item, index) in suggestQuestionListProp"
            :key="index"
            class="list_wrap__item"
            @click="$emit('on-send-suggest-question', item)"
            @mouseenter="isMouse = true"
            @mouseleave="isMouse = false"
          >
            <div class="left_wrap">
              <img src="@/components/aiChat/images/svg/jinghaoIcon.svg" class="icon">
              <div class="question-content">
                <Tooltip :data="item" :keyName="'label'" class="label"></Tooltip>
                <p v-if="$store.state.aiChat.zzpSelectBtn && $store.state.aiChat.zzpSelectBtn.length > 0" class="current-reference-text">
                  当前引用：
                  <span v-for="(tool, i) in $store.state.aiChat.zzpSelectBtn" :key="i"> {{ btnListConfig[tool.type] }}； </span>
                </p>
              </div>
            </div>
            <img src="@/components/aiChat/images/svg/xiangyoujiantouIcon2.svg" class="icon right_wrap one">
            <img src="@/components/aiChat/images/svg/xiangyoujiantouIcon.svg" class="icon right_wrap two">
          </div>
        </div>
      </el-scrollbar>
    </div>
    <p class="c-suggest_question__hint">{{ sourceType === 'wenshu' ? '我可以帮你查询数据的问题，试试问我吧~' : '我可以帮你解答系统功能和操作使用方面的问题，试试问我吧~' }}</p>
  </div>
</template>

<script>
import Tooltip from "@/components/aiChat/components/tooltip/tooltip.vue";
export default {
  components: {
    Tooltip,
  },
  props: {
    suggestQuestionListProp: {
      type: Array,
      default() {
        return [];
      },
    },
    source: {
      type: String,
      default: ''
    },
    sourceType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isMouse: false,
      btnListConfig: {
        1: '原始简历',
        2: '标准简历',
        3: '测评结果',
        4: '面试录音',
        5: '录音文本',
        6: '工作职责',
        7: '任职资格',
        8: '职位名称',
        9: '职位画像',
      }
    };
  },
};
</script>

<style lang="scss" scoped>
//@import "styles/index.scss";

.c-suggest_question {
  display: flex;
  flex-direction: column;
  padding-right: 16px;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  > img {
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }
  .c-suggest_question__content {
    display: none;
    margin-top: 10px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 16px;
    // border: 1px solid #fff;
    position: relative;
    &:before {
      content: "";
      background: url("~@/components/aiChat/images/bg.png") no-repeat;
      background-size: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    padding: 16px 0 16px 16px;
    .title {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      line-height: 20px;
      color: #1d2129;
    }
    .label {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      font-weight: 500;
      color: #1d2129;
    }
    .c-scrollbar {
      margin-top: 16px;
      height: calc(100vh - 505px);
      ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-bottom: 0 !important;
      }
      ::v-deep .el-scrollbar__bar {
        .is-horizontal {
          display: none;
        }
      }
    }
    .list_wrap {
      padding-right: 16px;

      &__item {
        padding: 10px 12px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0);
        border-radius: 21px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        cursor: pointer;
        align-items: flex-start;
        .icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
        .label {
          white-space: pre-line;
        }

        .left_wrap {
          display: flex;
          align-items: center;
          overflow: hidden;
          align-items: flex-start;
          flex: 1;
          .icon {
            margin-right: 4px;
            margin-top: 2px;
          }
          .question-content {
            flex: 1;
            overflow: hidden;
            .current-reference-text {
              font-size: 12px;
              font-style: italic;
              text-decoration: underline;
              color: #86909c;
              margin-top: 4px;
              margin-bottom: 0;
              line-height: 18px;
            }
          }
        }
        .right_wrap {
          &.one{
            display: none;
          }
          &.two{
            display: block;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.04);
        }
      }
    }
    .list_wrap__item{
      &:hover{
        .right_wrap {
          &.two{
            display: none;
          }
          &.one{
            display: block;
          }
        }
      }
    }
  }
  .c-suggest_question__hint {
    margin-top: 16px;
    padding: 0 16px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: #86909c;
    text-align: center;
  }
}
</style>